import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import '../App.css';

export const LandingPage = () => (
  <Box className="LandingPage" p={4}>
    <Box sx={{ textAlign: 'center', mb: 4 }}>
      <Typography variant="h2">
        {/* Welcome to FIPOK */}
        Üdvözöljük a FIPOK rendszerben!
        </Typography>
      <Typography variant="body1" mt={2}>
        {/* Measurement and evaluation system supporting psychological examinations based on synchronized measurement of bio-physiological and cognitive indicators */}
        Biofiziológiai és kognitív mutatók szinkron mérésén alapuló pszichológiai vizsgálatokat támogató mérő- és értékelő rendszer
      </Typography>
      <Typography variant="body1" mt={2}>
        {/* The FIPOK system provides objective measurement data for forming psychological opinion during HR selection processes, vocational aptitude tests, and psychological condition assessments. */}
        A FIPOK rendszer objektív mérési adatokat biztosít a pszichológiai vélemény kialakításához a HR kiválasztási folyamatok, a szakmai alkalmassági vizsgálatok és a pszichológiai állapotfelmérések során.
      </Typography>
      <Typography variant="body1" mt={2}>
        {/* The FIPOK system is a tool that can measure how well someone performs in different areas of thinking while they do cognitive exercises. At the same time, it keeps track of certain physical responses, such as the person's stress or relaxation levels and how often they blink. By doing this, it can help understand how well someone is able to handle difficult or stressful situations and how well they can recover from them. This system is useful for identifying areas where someone may need more support or training to improve their cognitive abilities and overall well-being. */}
        A FIPOK rendszer egy olyan eszköz, amely képes mérni, hogy valaki milyen jól teljesít a gondolkodás különböző területein, miközben kognitív gyakorlatokat végez. Ugyanakkor nyomon követi bizonyos fizikai reakciókat, például a személy stressz- vagy relaxációs szintjét, valamint a pislogás gyakoriságát. Ezzel segíthet megérteni, hogy valaki mennyire képes kezelni a nehéz vagy stresszes helyzeteket, és mennyire tud kiheverni belőlük. Ez a rendszer hasznos azon területek azonosítására, ahol valakinek több támogatásra vagy képzésre lehet szüksége kognitív képességeinek és általános jólétének javítása érdekében.
      </Typography>
      <Link
        href="https:/fipok.com"
        target="_blank"
        rel="noopener noreferrer"
        variant="body1"
        underline="hover"
        mt={3}
      >
        Tudjon meg többet itt
      </Link>
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {/* <img src="../../public/logo192.png" alt="Image 1" />
          <img src="/logo192.png" alt="Image 2" /> */}
      {/* Add more images as needed */}
    </Box>
  </Box>
);